// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"f140b32b","629":"9a01a571"}[chunkId] + ".chunk.js";
};